// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__BNTy8","formLabel":"Radio_formLabel__3lpsO"};